<template>
  <v-dialog :value="show" 
    :scrollable="scrollable" 
    :persistent="persistent" 
    :width="width" 
    :height="height" 
    @input="$emit('changeValue', $event)">
    <v-card class="px-4 pt-4 pb-4">
      <v-card-title>
        <h2>
          {{ title }}
        </h2>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap py-2 px-4>
          <v-flex xs12>
            <slot name="content"></slot>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout>
          <v-flex class="text-xs-right xs12" pr-4>
            <v-btn flat color="black" @click="$emit('changeValue', false)">
              CANCELAR
            </v-btn>
            <v-btn class="k-orange-linear-text" flat @click="$emit('save')" :disabled="disableSaveBtn">
              {{saveText}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    saveText: {
      type: String,
      default: 'Guardar',
    },
    width: {
      type: String,
      default: '600px',
    },
    height: {
      type: String,
      default: '600px',
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    disableSaveBtn: {
      type: Boolean,
      default: false,
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/global/SaveDialogV2.vue